<template>
  <enfold>
    <enfold-uc>
      <template slot="up">
        <div class="c-u-left flex-b-c">
          <el-button size="mini" round type="primary" @click="$router.go(-1)">{{ $t('nstm59') }}</el-button>
          <el-button size="mini" round type="primary" @click="dialogVisible = true">{{ $t('cscn1') }}</el-button>
        </div>
        <div class="c-u-right">

        </div>
      </template>
      <template slot="center">
        <div id="add_point" style="width: 100%;height: 100%;"></div>
      </template>
    </enfold-uc>
    <el-dialog :title="$t('nstm60')" :visible.sync="outerVisible" top="0vh" width="400px">
      <play-list :innerVisible="innerVisible" @closeDialog="closeDialog"></play-list>
      <div class="point-set" v-if="point">
        <div class="play flex-b-c">
          <span> {{ $t('nstm62') }}: </span>
          <span style="cursor: pointer;" @click="innerVisible = true">
            {{ point.playInfo ? point.playInfo.name : $t('nstm63') }} <i class="el-icon-arrow-right"></i>
          </span>
        </div>
        <div class="flex-b-c">
          <span> {{ $t('cbpl01') }}: </span>
          <set-radius @setRadiusSize="setRadiusSize" :defaultSize="point.radius"></set-radius>
        </div>
        <div>
          <span>{{ point.title || "" }}</span>
          <br />
          <span>{{ point.lnglat || "" }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addPointSet(false)">{{ $t('cdce7') }}</el-button>
        <el-button @click="addPointSet(true)" type="primary">{{ $t('cdce6') }}</el-button>
      </div>
    </el-dialog>
    <msg-dialog :dialogVisible="dialogVisible" @closeDialog="closePointName" :title="$t('nstm64')">
      <div class="flex-b-c">
        <div style="width: 100px">{{ $t('ctce2') }}:</div><el-input v-model="pointName" :placeholder="$t('nstm35')"
          size="small"></el-input>
      </div>
    </msg-dialog>
  </enfold>
</template>

<script>
import EnfoldUc from "@/components/basics/EnfoldUC"
import Enfold from "@/components/basics/Enfold"
import MsgDialog from "@/components/basics/MsgDialog";
import AMapLoader from '@amap/amap-jsapi-loader';
import PlayList from "@/components/basics/PlayList"
import SetRadius from './SetRadius';
// import gpsConversion from '@/assets/scripts/gpsConversion.js';
export default {
  name: "AddPoint",
  components: {
    EnfoldUc,
    Enfold,
    PlayList,
    SetRadius,
    MsgDialog
  },
  data() {
    return {
      pointList: [],
      outerVisible: false,
      innerVisible: false,
      dialogVisible: false,
      pointName: "",
      point: null
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: 'ba31d341e2b5184d678f1a550cc6b5d9', // 请替换为你的高德地图API密钥
        version: '1.4.15',
        plugins: ['AMap.Geocoder']
      }).then(AMap => {
        this.AMap = AMap;
        // 初始化地图
        const map = new AMap.Map('add_point', {
          // center: [116.397428, 39.90923], // 中心点经纬度
          zoom: 10, // 缩放级别
        });
        this.map = map;

        map.on('click', async (e) => {
          const { lng, lat } = e.lnglat;
          // console.log(`经度: ${e.lnglat.lng}, 纬度: ${e.lnglat.lat}`);

          let address = this.$t('nstm61');
          await this.geocoder(lng, lat).then((res) => {
            address = res;
          });

          this.point = { lnglat: [lng, lat], title: address, radius: 2, playInfo: null };
          this.outerVisible = true;
        });

      }).catch(e => {
        console.error(e);
      });
    },
    geocoder(lon, lat) {
      return new Promise((resolve, reject) => {
        if (!this.AMap) { return; }
        const geocoder = new this.AMap.Geocoder();
        geocoder.getAddress([lon, lat], (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const address = result.regeocode.formattedAddress; // 获取地址名称
            resolve(address);
          } else {
            reject(this.$t("nstm65"));
            console.error('获取地址失败:', result);
          }
        });
      });
    },
    initMarker() {
      this.pointList.forEach(point => {
        console.log(point);
        const { lnglat, title } = point;
        const marker = new this.AMap.Marker({
          position: lnglat,
          map: this.map,
          title: title
        });

        // 可以选择性地为每个标记点添加事件监听器  
        marker.on('click', (e) => {
          console.log(e);
          console.log('点击了标记点：', title);
          this.point = point;
          this.outerVisible = true;
          // this.map.remove(e.target);
        });
      });
    },
    closeDialog(isConfirm, program) {
      // console.log(isConfirm, program);
      if (isConfirm) {
        this.point.playInfo = program;
      }
      this.innerVisible = false;
    },
    closePointName(isConfirm) {
      if (isConfirm) {
        if (!this.pointName) {
          this.$msg({ message: this.$t("nstm67"), type: "warning", showClose: true });
          return;
        }
        let list = this.pointList.map((point) => {
          const { radius, lnglat: [lng, lat], playInfo: { id, name }, title } = point;
          return {
            group_id: this.$cookies.get("group_id"),
            name: this.pointName,
            point: title,
            lng, lat,
            radius,
            play_id: id,
            play_name: name,
          }
        });

        this.$http.post('/admin/device/setPoint', {
          point: encodeURIComponent(JSON.stringify(list)),
        }, () => {
          this.$router.go(-1);
        })
      }
      this.dialogVisible = false;
    },
    setRadiusSize(val) {
      this.point.radius = val;
    },
    addPointSet(Bool) {
      if (Bool) {
        if (!(this.point.radius && this.point.playInfo)) {
          this.$msg({
            message: this.$t('nstm68'),
            type: "warning",
            showClose: true
          });
          return;
        }
        this.pointList.push(this.point);
        this.initMarker();
      }
      this.outerVisible = false;
    }
  },
}
</script>

<style lang="scss" scoped>
.point-set {

  // .play {}
  div {
    margin: 8px 0px;
  }
}

/deep/ .el-dialog {
  margin: 0px;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__header {
  padding: 16px;
  border-radius: 8px 8px 0px 0px;
  // background-image: linear-gradient(270deg,
  //     #86eae7 0%,
  //     #4cccf0 45%,
  //     #11adf8 100%),
  //   linear-gradient(#ffffff, #ffffff);
  // background-blend-mode: normal, normal;
  background-color: var(--theme-color-customized-1);

  .el-dialog__title {
    font-size: 20px;
    color: #fff;
  }
}

/deep/ .el-dialog__body {
  padding: 16px;
  overflow: hidden;
}

/deep/ .el-dialog__footer {
  padding: 0px 16px 16px;
  border-radius: 0px 0px 8px 8px;

  /deep/ .el-button+.el-button {
    margin-left: 20px;
  }
}
</style>